import { NgModule } from '@angular/core';
import { ProfileGuardDirective } from '@directives/profile-guard.directive';
import { TooltipDirective } from '@directives/tooltip.directive';
import { DropzoneDirective } from '@directives/dropzone.directive';
import { SkeletorValueAccessor } from '@directives/skeletor-value-accessor.directive';

@NgModule({
  imports: [],
  declarations: [ProfileGuardDirective, TooltipDirective, DropzoneDirective, SkeletorValueAccessor],
  exports: [ProfileGuardDirective, TooltipDirective, DropzoneDirective, SkeletorValueAccessor],
  providers: []
})
export class DirectivesModule {
  constructor() {}
}
